module.exports = __webpack_public_path__ + "img/icon-floating-insta.2fa21f6f.svg";